import { createFileRoute } from "@tanstack/react-router";
import { RewardsPositionsPage } from "../../features/rewards/pages/rewards-positions-page";

export const Route = createFileRoute("/_layout/rewards/positions")({
  component: RewardsPositionsPage,
});
